//frontend/src/dropdownMap/1A3b_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    7: "StorageBuilt",
    10: "ConductedBy",
    11: "CommitteeExist",
    18: "Gender",
    19: "ParticipantRole",
    21: "PovertyLevel",
    22: "PWDStatus",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose
    //NOTE: form_1a3b has zero live submissions in the local DB as of this writing, so these
    //option sets are inferred from the translation_en_la registry + label semantics, not
    //cross-checked against real observed data like other forms' dropdowns.

    StorageBuilt: {
        internal: ["construction", "Rehabilitation"],
        LA: { "construction": "ສ້າງສາງໃໝ່", "Rehabilitation": "ປັບປຸງສາງທີມີຢູ່ແລ້ວ" },
        EN: { "construction": "Construction of a Rice Bank", "Rehabilitation": "Rehabilitation of a Rice Bank" }
    },

    ConductedBy: {
        internal: ["npco", "gst", "dafo", "pafo", "wfp", "maf"],
        LA: {
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ",
            "maf": "ກະຊວງ ກປ"
        },
        EN: { "npco": "NPCO", "gst": "GST", "dafo": "DAFO", "pafo": "PAFO", "wfp": "WFP", "maf": "MAF" }
    },

    CommitteeExist: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    ParticipantRole: {
        internal: ["1", "2", "3"],
        LA: { "1": "ສ້າງ", "2": "ກູ້ຢືມ", "3": "ສ້າງ+ຢືມ" },
        EN: { "1": "Developer", "2": "Borrower", "3": "Developer+Borrower" }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
